import React from 'react';
import type { WhatsAppTemplateButton } from '../../models/MasterAdmin/whatsappCampaign';
import type { DeepLinkCampaign } from '../../models/MasterAdmin/deepLink';
import {
  resolveTemplateButtonPreviewUrl,
  templateButtonTypeLabel,
} from './whatsappTemplatePreview';

type Props = {
  buttons?: WhatsAppTemplateButton[] | null;
  campaignsById?: Map<string, DeepLinkCampaign>;
  className?: string;
};

const WhatsAppTemplateButtonsPreview: React.FC<Props> = ({
  buttons,
  campaignsById,
  className = '',
}) => {
  const rows = buttons || [];
  if (!rows.length) return null;

  return (
    <div className={className}>
      <p className="text-xs font-medium uppercase text-gray-400">Button links</p>
      <div className="mt-1 space-y-2">
        {rows.map((btn, i) => {
          const target = resolveTemplateButtonPreviewUrl(btn, campaignsById);
          const type = String(btn.type || '').toUpperCase();
          const isUrl = type === 'URL' || type === 'CALL_TO_ACTION' || type === 'WEBSITE';
          return (
            <div
              key={`${btn.type}-${btn.text}-${i}`}
              className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs dark:border-gray-700 dark:bg-gray-900"
            >
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-medium text-gray-900 dark:text-white">{btn.text || `Button ${i + 1}`}</span>
                <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] uppercase tracking-wide text-gray-600 dark:bg-gray-800 dark:text-gray-300">
                  {templateButtonTypeLabel(btn.type)}
                </span>
              </div>
              {target ? (
                isUrl ? (
                  <a
                    href={target}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-1 block break-all text-[#009de2] hover:underline"
                  >
                    {target}
                  </a>
                ) : (
                  <p className="mt-1 break-all text-gray-600 dark:text-gray-300">{target}</p>
                )
              ) : (
                <p className="mt-1 text-amber-700 dark:text-amber-300">No link saved on this button</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WhatsAppTemplateButtonsPreview;
